import { render, staticRenderFns } from "./WapProductSelectSubmit.vue?vue&type=template&id=70633668&"
import script from "./WapProductSelectSubmit.vue?vue&type=script&lang=js&"
export * from "./WapProductSelectSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports